const API_TOKEN_STORAGE_KEY = 'tr-nc_apiToken';

export const setApiToken = (apiToken: string) =>
    sessionStorage.setItem(API_TOKEN_STORAGE_KEY, apiToken);

export const getApiToken = () => sessionStorage.getItem(API_TOKEN_STORAGE_KEY);
